import { BaseDto } from 'src/dtos/common/baseDto';

/** hrm_certificate의 전송 필드와 그리드 편집 상태이다. */
export interface HrmCertificateDto extends BaseDto {
    certNo: string; // 서버가 채번하는 발급번호
    empNo: string; // 발급 대상 사번
    certType: string; // 증명서 종류
    issueDt: string; // 발급일 YYYY-MM-DD
    purpose: string; // 발급 용도
    submitTo: string; // 제출처
    copies: number; // 출력할 매수
    issueSts: string; // 신청·발급·취소 상태
    printCnt: number; // 누적 출력 횟수
    lastPrintDt: string; // 마지막 출력 시각
    issueUser: string; // 마지막 발급자
    remark: string; // 화면에서 사용하지 않는 DB 비고
    inserted: boolean; // true이면 아직 저장되지 않은 행
    isModified: boolean; // true이면 저장된 행의 값이 바뀜
}

/** 신규 행과 서버 응답에서 비어 있는 화면 필드를 채우는 기본값이다. */
export const defaultHrmCertificateDto: HrmCertificateDto = {
    valueIndex: 0, orderIndex: 0, orderIndexSeq: 0,
    certNo: '', empNo: '', certType: '', issueDt: '', purpose: '',
    submitTo: '', copies: 1, issueSts: '10', printCnt: 0,
    lastPrintDt: '', issueUser: '', remark: '', inserted: false, isModified: false,
};
